import { Button, Typography } from '@breetometer/components';
import { HourGlassIcon } from 'BreetAssets';

import type { ITopupExpiredProps } from '../helpers';

const TopupAccountExpired = ({ restartTopup }: ITopupExpiredProps) => (
	<div className='top-up-account-expired bg-primary-500'>
		<HourGlassIcon className='header-icon' />

		<Typography
			as='h2'
			className='color-error-400'
		>
			Account Expired
		</Typography>

		<Typography className='color-neutral-50'>
			Your previously generated account has expired. Click top-up to restart the process.
		</Typography>

		<div className='new-btn-cta'>
			<Button
				onClick={restartTopup}
				className='primary-hover border-dark-navy bg-tertiary-400 bg-tertiary-300-hover'
				type='button'
			>
				Top-Up
			</Button>
		</div>
	</div>
);

export default TopupAccountExpired;
